<template>
  <div>
    <loading v-if="showLoading"></loading>
    <div class="vx-card__body card-body">
      <div class="flex">
        <div class="w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('CustomerName') },
              { title: $t('CreateOn') },
              { title: $t('Action') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 25%">
                {{ row.checkOutInfo.dischargePermissionIssuerUserName }}
              </td>
              <td style="width: 20%;direction: ltr;">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 35%">
                <router-link
                  :to="{
                    path: '/Package/Details/0/' + row.id,
                    query: {
                      breadcrumbNameManual: {
                        persianTitle: 'عملیات اپراتور',
                        Title: 'OperationOperators'
                      }
                    }
                  }"
                >
                  <vs-button
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="mx-4 d-inline"
                  ></vs-button>
                </router-link>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "shipping-OperationOperators-cartable",
  components: {
    DataGrid,
    Loading
  },
  data() {
    return {
      permission296: "ChangePackageStateToOperatorApproved",
      showLoading: false,
      gridDataSource: {
        type: "app",
        service: "Shipping/api/PackagesQuery/by-logged-in-operator"
      },
      gridSearchData: {
        packageStateType: 1
      }
    };
  }
};
</script>
